import { EditIconSVGComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/edit-icon-svg/edit-icon-svg.component';
import { CheckEmailIconSvgComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/check-email-icon-svg/check-email-icon-svg.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AlertService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { PaperlessService } from '../../../../../../_services/_iam/paperless.service';
import { PolicyDataService } from '../../../../../../_services/my-insurance/data-services/policy-data.service';
import { UserService } from '../../../../../../_services/user.service';
import { ErrorRedirectionService } from '../../../../../../_services/error-service/error-redirection.service';
import { PaperlessDataService } from '../../../../../../_services/data-services/paperless-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent, CheckEmailIconSvgComponent, EditIconSVGComponent],
  selector: 'app-paperless-bill',
  templateUrl: './paperless-bill.component.html',
})
export class PaperlessBillComponent implements OnInit {
  endEnrollOptionsModal: ModalOptions;
  enrollOptionsModal: ModalOptions;
  hideModal = false;
  policyInfo: any;
  user: any;

  constructor(
    private alertService: AlertService,
    private policyDataService: PolicyDataService,
    private paperlessService: PaperlessService,
    private userService: UserService,
    private errorRedirectionService: ErrorRedirectionService,
    private paperlessDataService: PaperlessDataService
  ) {
    this.endEnrollOptionsModal = this.paperlessDataService.getRemovalModel(
      'modal-medium cancel-enroll modal-dialog',
      'red-text float-right align-middle no-padding no-margin flat',
      'MODAL_E-POLICY-REMOVAL_TITLE',
      'endEnrollModal',
      'MODAL_E-BILL-REMOVAL_TITLE'
    );

    this.enrollOptionsModal = this.paperlessDataService.getEnrollModel(
      'modal-medium enroll modal-dialog',
      'no-margin float-right btn mapfre waves-light primary ghost w-100',
      'ENROLL',
      'enrollModal',
      'MODAL_E-BILL-ENROLL_TITLE'
    );
  }

  cancellEnroll(policyid, email): void {
    this.paperlessService.cancelPaperlessEBill(policyid, email).subscribe(
      () => {
        this.alertService.error('EBILL_CANCEL');
      },
      (error) => {
        this.errorRedirectionService.errorHandler(
          error,
          'PROBLEM_IN_REQUEST_PROCESSING'
        );
      }
    );
  }

  enroll(policyid, email): void {
    this.paperlessService.enrollPaperlessEBill(policyid, email).subscribe(
      () => {
        this.alertService.success('EBILL_ENROLL');
      },
      (error) => {
        this.errorRedirectionService.errorHandler(
          error,
          'PROBLEM_IN_REQUEST_PROCESSING'
        );
      }
    );
  }

  hideModalAction(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
    }
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

  ngOnInit() {
    this.userService.$user.subscribe((user) => {
      this.user = user;
    });
    this.policyDataService.$policyDetails.subscribe((policyInfo) => {
      this.policyInfo = policyInfo;
    });
  }
}
